import { render, staticRenderFns } from "./AuthenticatedPage.vue?vue&type=template&id=1bda2780&"
import script from "./AuthenticatedPage.vue?vue&type=script&lang=js&"
export * from "./AuthenticatedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports